/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.booking', {
            parent: 'board.project-detail',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/bookings/bookings.html',
                    controller: 'ProjectDetailBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.booking.edit', {
            parent: 'board.project-detail.booking',
            url: '/{id2}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/bookings/booking-dialog.html',
                    controller: 'ProjectDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity2: ['ProjectDetailBooking', function(ProjectDetailBooking) {
                            return ProjectDetailBooking.get({id : $stateParams.id2}).$promise;
                        }],
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.booking.edit-dept', {
            parent: 'board.project-detail.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.booking.new-dept', {
            parent: 'board.project-detail.booking',
            url: '/dept/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
